module.exports = __webpack_public_path__ + "static/media/29.6a1b762b.jpg";